export default __webpack_public_path__ + "static/bf6ba50837677716de72fd7ca23230d7.ttf";